import React from 'react'
import VehicleCell from '../Pages/Stakeholder/Vehicle/VehicleCell'
import { constants } from '../../Helpers/Constants'
import DatePicker from '../Common/DatePicker'
import moment from 'moment'
import Select from 'react-select';
import { Trans } from 'react-i18next'

import EUEditBookingActionButton from "./EUEditBookingActionButton"
import { reverseReceiveTime } from '../../Helpers/ReceiveTimeInArray'


const EUEditBookingPullout = (
  {
    closePullout, submitEdit, editBooking,
    changeTime, updateForm, updateFormDropdown, selectStartDate,
    selectEndDate, state, ...props
  }
) => {
  return (
    <div className="booking_pullout_user">
      <div className="booking_header border-bottom">
        <div className="card-header-title no-margin float-left"><Trans>Edit Booking</Trans></div>
        <button onClick={closePullout} type='button' style={{ cursor: "pointer" }} className="float-right">
          <span aria-hidden='true' style={{ fontSize: "1.8em", lineHeight: 1, display: "block" }}>&times;</span>
        </button>
        <div className="clearfix"></div>
      </div>
      <div className="card-section">
        <div className="row mb-24">
          <h4><Trans>Vehicle</Trans></h4>
          <VehicleCell history={props.history} match={props.match} location={props.location} vehicle={props.endUser.current_booking.vehicle} showImage noOverlay noTooltip />
        </div>
        <div className="row">
          <h4 className="mb-8">Dates & Times</h4>
          <div className="datetime-field">
            <div className="body medium">Pick Up</div>
            <DatePicker id="booking_start_date" classname="date-input-field datetime-date date-field datepicker-start no-weekends"
              name="booking_start_date" placeholder="Choose Date" disabled={(props.endUser.current_booking.Prep_Status == constants.prep_status.out && props.endUser.current_booking.Released_On != null) ? true : false} booking_id={props.endUser.current_booking.BOOK_ID}
              value={
                state.tempLocaleTime.releaseDate ? state.tempLocaleTime.releaseDate
                  : state.vehicle_form.start_date ? moment(state.vehicle_form.start_date).format("MMM D, YYYY") : ""
              }
              updateValue={selectStartDate}
            />
            <div className="datetime-time select-eu-vehicle">
              <Select
                className="react_select_dropdown react_select_dropdown--hide-selected"
                classNamePrefix="react_select"
                onChange={changeTime}
                defaultValue={{
                  value: state.vehicle_form.pick_up_time,
                  label: state.tempLocaleTime.releaseTime && props.endUser.current_booking.Release_Time ? state.tempLocaleTime.releaseTime : props.endUser.current_booking.Release_Time ? reverseReceiveTime(props.endUser.current_booking.Release_Time) : '',
                  name: "pick_up_time"
                }}
                options={
                  state.pickup_timings.map((time) => ({
                    value: time.value,
                    label: time.option,
                    name: "pick_up_time"
                  })
                  )
                }
                isDisabled={(props.endUser.current_booking.Prep_Status == constants.prep_status.out && props.endUser.current_booking.Released_On != null) ? true : false}
              />
            </div>
            {
              props.endUser.current_booking.Prep_Status == constants.prep_status.out && props.endUser.current_booking.Released_On != null ?
                <>
                  <input type="hidden" name="booking_start_date" value={state.tempLocaleTime.releaseDate ? state.tempLocaleTime.releaseDate : state.vehicle_form.start_date ? moment(state.vehicle_form.start_date).format("MMM DD, YYYY") : ""} />
                  <input type="hidden" name="pick_up_time" value={state.tempLocaleTime.returnDate ? state.tempLocaleTime.returnDate : state.vehicle_form.pick_up_time} />
                </>
                :
                null
            }
            <div className="clearfix"></div>
          </div>
        </div>
        <div className="row">
          <div className="datetime-field">
            <div className="body medium"><Trans>Drop Off</Trans></div>
            <DatePicker id="booking_end_date" classname="date-input-field datetime-date date-field datepicker-end no-weekends"
              name="booking_end_date" placeholder="Choose Date" booking_id={props.endUser.current_booking.BOOK_ID}
              value={
                state.tempLocaleTime.returnDate ? state.tempLocaleTime.returnDate
                  : state.vehicle_form.end_date ? moment(state.vehicle_form.end_date).format("MMM D, YYYY") : ""
              }
              updateValue={selectEndDate}
              disabled={state.vehicle_form.start_date ? "" : "disabled"} start_date_id="booking_start_date"
              key={"booking_end_date_" + state.vehicle_form.start_date + "_" + state.vehicle_form.end_date}
            />
            <div className="datetime-time select-eu-vehicle">
              <Select
                className="react_select_dropdown react_select_dropdown--hide-selected"
                classNamePrefix="react_select"
                onChange={changeTime}
                defaultValue={{ 
                  value: state.vehicle_form.drop_off_time, 
                  label: state.tempLocaleTime.returnTime && props.endUser.current_booking.Return_Time ? state.tempLocaleTime.returnTime 
                  : props.endUser.current_booking.Return_Time ? reverseReceiveTime(props.endUser.current_booking.Return_Time) : 'drop_off_time',
                  label: moment(props.endUser.current_booking.Return_Time, "HH:mm:ss").format("h:mm A"), name: "drop_off_time" 
                }}
                options={
                  state.dropoff_timings.map((time) => {
                    return (
                      { value: time.value, label: time.option, name: "drop_off_time" }
                    )
                  })
                }
              />
            </div>
            <div className="clearfix"></div>
          </div>
        </div>
        <div className="row collapse">
          <h4 className="mb-8"><Trans>Booking Information</Trans></h4>
          <div className="columns large-12 medium-12 small-12">
            <label><Trans>Vehicle Usage</Trans>
              <Select
                className="react_select_dropdown"
                classNamePrefix="react_select"
                onChange={updateFormDropdown}
                defaultValue={{ value: props.endUser.current_booking.Usage_Type, label: props.settings.vehicle_usage_types[parseInt(props.endUser.current_booking.Usage_Type)], name: "vehicle_usage" }}
                options={
                  Object.keys(props.settings.vehicle_usage_types).map((key) => {
                    return (
                      { value: key, label: props.settings.vehicle_usage_types[key], name: "vehicle_usage" }
                    )
                  })
                }
              />
            </label>
          </div>
          <div className="columns large-12 medium-12 small-12 mt-8">
            <label><Trans>Booking Notes</Trans>
              <textarea defaultValue={props.endUser.current_booking.Special_Requests} name="notes" onChange={updateForm} />
            </label>
          </div>
        </div>
      </div>
      <div className="booking_bottom border-top">
        <a className="button ml-16" onClick={editBooking}><Trans>Cancel</Trans></a>
        <EUEditBookingActionButton legacyApiEditBooking={submitEdit} settings={props.settings} gqlBooking={props?.endUser?.current_booking?.extendedProps?.booking} />
      </div>
    </div>
  )
}

export default EUEditBookingPullout